<template>
  <div
    class="swiper__controls"
    :class="additionalClass"
  >
    <button class="swiper__button swiper__button--prev">
      <swiper-arrow></swiper-arrow>
    </button>
    <div class="swiper-pagination"></div>
    <button class="swiper__button swiper__button--next">
      <swiper-arrow></swiper-arrow>
    </button>
  </div>
</template>

<script>
  import SwiperArrow from '~/assets/icons/swiper-arrow.svg'

  export default {
    name: 'SwiperControls',
    components: {
      SwiperArrow
    },
    props: {
      type: {
        type: String,
        default: ''
      }
    },
    computed: {
      additionalClass() {
        return this.type === 'inverse'
          ? 'swiper__controls--inverse'
          : ''
      }
    }
  }
</script>

<style lang="scss">
  .swiper__controls {
    z-index: 1;
    position: relative;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;

    .swiper-pagination {
      position: relative;
      bottom: 0;
      min-width: 40px;
      margin: auto 21px;
      font-size: 14px;
      color: $primary;
    }
  }

  .swiper__button {
    padding: 0;
    background-color: transparent;
    border: none;
    appearance: none;
    line-height: 1;

    &:hover {
      cursor: pointer;

      svg {
        fill: $primary;
      }
    }

    &:focus {
      outline: none;
    }

    &--prev {
      svg {
        transform: rotate(180deg);
      }
    }

    svg {
      max-width: 16px;
      max-height: 28px;
      fill: rgba($primary, 0.4);
      transition: fill 0.1s;
    }
  }

  .swiper__controls--inverse {
    .swiper-pagination {
      color: #FFF;
    }

    .swiper__button {
      &:hover {
        svg {
          fill: #FFF;
        }
      }

      svg {
        fill: rgba(#FFF, 0.6);
      }
    }
  }
</style>